import React, { useState } from 'react'
import { Container } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { Field } from '@progress/kendo-react-form'
import { Grid } from "@material-ui/core"
import './direction.css'
import { Fragment } from 'react'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { Label } from '@progress/kendo-react-labels'
import PhoneInput from 'react-phone-number-input'

const TooltipContentTemplate = (props) => {
  return (
    <a>
      <strong>{props.title}</strong>
      <p>{props.content}</p>
      <p>{props.subContent}</p>
      <p>{props.restContent}</p>
    </a>
  );
};

function DirectionPure(props) {
  const { t } = useTranslation()
  const [firstName, setFirstName] = useState(false)
  const [firstLastName, setFirstLastName] = useState(false)
  const [secondLastName, setSecondLastName] = useState(false)
  const [rfc, setRfc] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState(false)
  const [cellNumber, setCellNumber] = useState('')
  const [cellNumberFocus, setCellNumberFocus] = useState(false)
  const [street, setStreet] = useState(false)
  const [colony, setColony] = useState(false)
  const [township, setTownship] = useState(false)
  const [state, setState] = useState(false)
  const [zipCode, setZipCode] = useState(false)

  const iconTooltipStyles = {
    color: '#687687',
    fontSize: '15px',
    // marginLeft: '5px',
    padding: '5px',
    cursor: 'pointer'
  }

  const [open, setOpen] = useState(false);
  const handleOnChangeTooltip = () => setOpen(!open)
  const hiddeTooltip = () => setOpen(false)
  const { selectedPersonTypeId } = props

  const handlePreventReload = (e) => {
    if(e.key === 'Enter'){
      e.preventDefault()
    }
}   

  return (
    <Fragment>
      <Container className='direction-display-flex' spacing={6} lg={12} md={12} sm={6} xs={12} >
        <fieldset className='direction-field'>
          <Grid container className='container direction-display-block' spacing={4}>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              {/* <span className='direction-display-span'>{t('register.personalData.name')}</span> */}
              <div className='direction-tooltip-movil'>
                {/* <Tooltip
                  position="right"
                  anchorElement="target"
                  content={(props) => {
                    return <TooltipContentTemplate
                      title={open ? t('register.personalData.name') : props.title}
                      content={(open ? (selectedPersonTypeId === 1) ? t('directionPure.name') : t('directionPure.nameCorporativa') : '')}
                    />
                  }}
                > */}
                <Label className="direction-form-labels ">
                  {t('register.personalData.name')}
                  {/* <i
                      className="k-icon k-i-information"
                      style={iconTooltipStyles}
                      title={t('signatureRequestView2.tooltipClic')}
                      onClick={() => handleOnChangeTooltip()}
                      onMouseOut={() => hiddeTooltip()}
                    /> */}
                </Label>
                {/* </Tooltip> */}
              </div>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setFirstName(false) }}
                  onBlur={() => { setFirstName(true) }}
                  name={"firstName"}
                  component={props.validateInput}
                  validator={firstName && props.validator.nameValidator}
                  minLength={2} required
                  autoFocus
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.personalData.firstLastName')}</span>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setFirstLastName(false) }}
                  onBlur={() => { setFirstLastName(true) }}
                  name={"firstLastName"}
                  component={props.validateInput}
                  validator={firstLastName && props.validator.firstLastNameValidator}
                  minLength={2}
                  required
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.personalData.secoundLastName')}</span>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setSecondLastName(false) }}
                  onBlur={() => { setSecondLastName(true) }}
                  name={"secondLastName"}
                  component={props.validateInput}
                  validator={secondLastName && props.validator.secondLastNameValidator}
                  minLength={2}
                  required
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            {props.selectedPersonTypeId === 1 ?
              <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
                {/* <span className='direction-display-span'> {t('register.personalData.rfc')}</span> */}
                <div className='direction-tooltip-movil'>
                  {/* <Tooltip
                    position="right"
                    anchorElement="target"
                    content={(props) => {
                      return <TooltipContentTemplate title={open ? t('register.personalData.rfc') : props.title} content={open ? t('directionPure.rfc') : ''} />
                    }}
                  > */}
                  <Label className="direction-form-labels">
                    {t('register.personalData.rfc')}
                    {/* <i
                        className="k-icon k-i-information"
                        style={iconTooltipStyles}
                        title={t('signatureRequestView2.tooltipClic')}
                        onClick={() => handleOnChangeTooltip()}
                        onMouseOut={() => hiddeTooltip()}
                      /> */}
                  </Label>
                  {/* </Tooltip> */}
                </div>
                <div className='direction-input-movil'>
                  <Field
                    className='direction-input-data'
                    onFocus={() => { setRfc(false) }}
                    onBlur={() => { setRfc(true) }}
                    name={"rfc"}
                    component={props.validateInput}
                    validator={rfc && (props.validator.rfcValidator || rfc === '')}
                    onKeyPress={(e) => handlePreventReload(e)}
                  />
                </div>
              </Grid>
              : null
            }
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.personalData.cellphone')}</span>
              <div className='direction-input-movil'>
                <PhoneInput
                  placeholder="Ingresa el telefono"
                  value={props.cellphoneNumber}
                  onChange={props.onChangeCellphone}
                  defaultCountry="MX"
                  international
                  name={"cellphoneNumber"}
                  countryCallingCodeEditable={false}
                  onFocus={() => { setCellNumberFocus(false) }}
                  onBlur={() => { setCellNumberFocus(true) }}
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.personalData.phone')}</span>
              <div className='direction-input-movil'>
                <PhoneInput
                  placeholder="Ingresa el telefono"
                  value={props.phoneNumber}
                  onChange={props.onChangePhone}
                  defaultCountry="MX"
                  international
                  name={"phoneNumber"}
                  countryCallingCodeEditable={false}
                  onFocus={() => { setCellNumberFocus(false) }}
                  onBlur={() => { setCellNumberFocus(true) }}
                  onKeyPress={(e) => handlePreventReload(e)}
                />
                {/* <Field
                  className='direction-input-data'
                  // onFocus={() => { setPhoneNumber(false) }}
                  // onBlur={() => { setPhoneNumber(true) }}
                  name={"phoneNumber"}
                  component={props.validateInput}
                  validator={phoneNumber && props.validator.phoneValidator}
                  maxLength={10}
                /> */}
              </div>
            </Grid>
          </Grid>
        </fieldset>
        <fieldset className='direction-field'>
          <Grid container className='container direction-display-block' spacing={4}>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              {/* <span className='direction-display-span'> {t('register.address.street')}</span> */}
              <div className='direction-tooltip-movil'>
                {/* <Tooltip
                  position="right"
                  anchorElement="target"
                  content={(props) => {
                    return <TooltipContentTemplate
                      title={open ? t('register.address.street') : props.title}
                      content={open ? (selectedPersonTypeId === 1) ? t('directionPure.street') : t('directionPure.streetCorporativa') : ''}
                    />
                  }}
                > */}
                <Label className="direction-form-labels">
                  {t('register.address.street')}
                  {/* <i
                      className="k-icon k-i-information"
                      style={iconTooltipStyles}
                      title={t('signatureRequestView2.tooltipClic')}
                      onClick={() => handleOnChangeTooltip()}
                      onMouseOut={() => hiddeTooltip()}
                    /> */}
                </Label>
                {/* </Tooltip> */}
              </div>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setStreet(false) }}
                  onBlur={() => { setStreet(true) }}
                  name={"street"} component={props.validateInput}
                  validator={street && props.validator.addressValidator}
                  minLength={2}
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.address.suburb')}</span>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setColony(false) }}
                  onBlur={() => { setColony(true) }}
                  name={"colony"}
                  component={props.validateInput}
                  validator={colony && props.validator.suburbValidator}
                  minLength={2}
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            {/* <Grid  className='grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.address.externalNumber')}</span>
              <Field className='direction-input-data' onFocus={() => {setExternalNumber(false)}} onBlur={() => {setExternalNumber(true)}} name={"externalNumber"} component={props.validateInput} validator={externalNumber && props.validator.externalNumberValidator} minLength={2} required />
              </Grid>
              <Grid  className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.address.internalNumber')}</span>
              <Field className='direction-input-data' onFocus={() => {setInternalNumber(false)}} onBlur={() => {setInternalNumber(true)}} name={"internalNumber"} component={props.validateInput} validator={internalNumber && props.validator.internalNumberValidator} />
            </Grid> */}
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.address.town')}</span>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setTownship(false) }}
                  onBlur={() => { setTownship(true) }}
                  name={"township"}
                  component={props.validateInput}
                  validator={township && props.validator.townValidator}
                  minLength={3}
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.address.state')}</span>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setState(false) }}
                  onBlur={() => { setState(true) }}
                  name={"state"}
                  component={props.validateInput}
                  validator={state && props.validator.stateValidator}
                  minLength={3}
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
            <Grid className='direction-grid-complete' item xs={12} lg={6} md={12} sm={12} es={12}>
              <span className='direction-display-span'> {t('register.address.zipCode')}</span>
              <div className='direction-input-movil'>
                <Field
                  className='direction-input-data'
                  onFocus={() => { setZipCode(false) }}
                  onBlur={() => { setZipCode(true) }}
                  name={"zipCode"}
                  component={props.validateInput}
                  validator={zipCode && props.validator.zipCodeValidator}
                  minLength={5}
                  onKeyPress={(e) => handlePreventReload(e)}
                />
              </div>
            </Grid>
          </Grid>
        </fieldset>
      </Container>
      <p className='direction-note' >{t('register.address.requiredData')}</p>
    </Fragment>
  )
}

export { DirectionPure as default }
